module.exports = __webpack_public_path__ + "./fonts/TTNorms-Regular.otf";